// Swiper for upsell
if (typeof Swiper !== "undefined" && document.querySelector("#upsell-swiper")) {
  const upsellSwiper = new Swiper("#upsell-swiper", {
    autoplay: {
      delay: 5000, //5sec
      disableOnInteraction: false,
    },
    loop: true,
    speed: 800,
    slidesPerView: 1,
    spaceBetween: 0,
    effect: "slide",
    pagination: {
      el: ".upsell-swiper-pagination",
      clickable: true,
    },
  });
}

// Custom HTML Element pour les upsells de produits
class ProductUpsell extends HTMLElement {
  constructor() {
    super();
    this.abortController = null;
  }

  connectedCallback() {
    this.abortController = new AbortController();
    this.bindEvents();
    this.getRecommendations();
  }

  disconnectedCallback() {
    if (this.abortController) {
      this.abortController.abort();
    }
  }

  bindEvents() {
    const addToCartLinks = this.querySelectorAll(".upsell-add-to-cart-link, .upsell-add-to-cart-auto-link, .upsell-add-to-cart-auto-1-link, .upsell-add-to-cart-auto-2-link");

    addToCartLinks.forEach((link) => {
      link.addEventListener("click", this.handleAddToCart.bind(this), {
        signal: this.abortController.signal,
      });
    });
  }

  async handleAddToCart(e) {
    e.preventDefault(); // Empêcher la navigation par défaut

    const link = e.currentTarget;
    const productId = link.getAttribute("data-product-id");
    const productTitle = link.getAttribute("data-product-title");

    // Désactiver le lien pendant la requête
    this.setLinkLoadingState(link, true);
    const originalText = link.textContent;
    link.textContent = "Ajout...";

    try {
      // Déclencher les événements de chargement comme le thème
      document.documentElement.dispatchEvent(
        new CustomEvent("theme:loading:start", { bubbles: true })
      );

      // Préparer les sections à bundler (comme le thème fait)
      let sectionsToBundle = [];
      document.documentElement.dispatchEvent(
        new CustomEvent("cart:prepare-bundled-sections", {
          bubbles: true,
          detail: { sections: sectionsToBundle },
        })
      );

      // Utiliser FormData comme le thème
      const formData = new FormData();
      formData.set("id", productId);
      formData.set("quantity", "1");
      formData.set("sections", sectionsToBundle.join(","));
      formData.set(
        "sections_url",
        `${Shopify.routes.root}variants/${productId}`
      );

      const response = await fetch(`${Shopify.routes.root}cart/add.js`, {
        body: formData,
        method: "POST",
        headers: {
          "X-Requested-With": "XMLHttpRequest",
        },
      });

      const responseJson = await response.json();
      document.documentElement.dispatchEvent(
        new CustomEvent("theme:loading:end", { bubbles: true })
      );

      if (response.ok) {
        // Succès - afficher un message temporaire
        this.setLinkSuccessState(link, "Ajouté !");

        // Vérifier le type de panier comme le thème
        if (
          window.themeVariables?.settings?.cartType === "page" ||
          window.themeVariables?.settings?.pageType === "cart"
        ) {
          return (window.location.href = `${Shopify.routes.root}cart`);
        }

        // Récupérer le contenu du panier comme le thème
        const cartContent = await (
          await fetch(`${Shopify.routes.root}cart.js`)
        ).json();
        cartContent["sections"] = responseJson["sections"];

        // Déclencher les événements comme le thème fait
        document.documentElement.dispatchEvent(
          new CustomEvent("cart:change", {
            bubbles: true,
            detail: {
              baseEvent: "variant:add",
              onSuccessDo: "force_open_drawer", // Forcer l'ouverture du drawer
              cart: cartContent,
            },
          })
        );

        // Restaurer le lien après 2 secondes
        setTimeout(() => {
          this.restoreLinkState(link, originalText);
        }, 2000);
      } else {
        throw new Error(
          responseJson["description"] || "Erreur lors de l'ajout au panier"
        );
      }
    } catch (error) {
      document.documentElement.dispatchEvent(
        new CustomEvent("theme:loading:end", { bubbles: true })
      );
      console.error("Erreur:", error);
      this.setLinkErrorState(link, "Erreur");

      // Restaurer le lien après 2 secondes
      setTimeout(() => {
        this.restoreLinkState(link, originalText);
      }, 2000);
    }
  }

  setLinkLoadingState(link, isLoading) {
    if (isLoading) {
      link.style.pointerEvents = "none";
      link.style.opacity = "0.7";
    } else {
      link.style.pointerEvents = "";
      link.style.opacity = "";
    }
  }

  setLinkSuccessState(link, text) {
    link.textContent = text;
  }

  setLinkErrorState(link, text) {
    link.textContent = text;
  }

  restoreLinkState(link, originalText) {
    link.textContent = originalText;
    this.setLinkLoadingState(link, false);
  }

  async getRecommendations() {
    const productId = this.getAttribute("data-product-id");

    if (!productId) {
      console.error("Aucun product ID trouvé sur l'élément product-upsell");
      return;
    }

    try {
      const response = await fetch(
        window.Shopify.routes.root +
          "recommendations/products.json?product_id=" +
          productId +
          "&limit=2&intent=related"
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      console.log("Données de recommandations:", data);

      if (data.products && data.products.length > 0) {
        const firstProduct = data.products[0];
        const secondProduct = data.products[1];
        
        // PREMIER PRODUIT (slide 1)
        const firstProductTitle = this.querySelector('.upsell-container__product-auto-1-title');
        if (firstProductTitle && firstProduct) {
          firstProductTitle.textContent = firstProduct.title;
        }
        
        const firstProductImage = this.querySelector('.upsell-container__product-auto-1-image');
        if (firstProductImage && firstProduct.featured_image) {
          firstProductImage.innerHTML = `<img src="${firstProduct.featured_image}" alt="${firstProduct.title}">`;
        }
        
        const firstProductPrice = this.querySelector('.upsell-container__product-auto-1-price');
        if (firstProductPrice && firstProduct.price_min) {
          const price = (firstProduct.price_min / 100).toFixed(2);
          firstProductPrice.textContent = `${price}€`;
        }
        
        const firstAutoLink = this.querySelector('.upsell-add-to-cart-auto-1-link');
        if (firstAutoLink && firstProduct.variants && firstProduct.variants.length > 0) {
          firstAutoLink.setAttribute('data-product-id', firstProduct.variants[0].id);
          firstAutoLink.setAttribute('data-product-title', firstProduct.title);
        }
        
        // DEUXIÈME PRODUIT (slide 2)
        if (secondProduct) {
          const secondProductTitle = this.querySelector('.upsell-container__product-auto-2-title');
          if (secondProductTitle) {
            secondProductTitle.textContent = secondProduct.title;
          }
          
          const secondProductImage = this.querySelector('.upsell-container__product-auto-2-image');
          if (secondProductImage && secondProduct.featured_image) {
            secondProductImage.innerHTML = `<img src="${secondProduct.featured_image}" alt="${secondProduct.title}">`;
          }
          
          const secondProductPrice = this.querySelector('.upsell-container__product-auto-2-price');
          if (secondProductPrice && secondProduct.price_min) {
            const price = (secondProduct.price_min / 100).toFixed(2);
            secondProductPrice.textContent = `${price}€`;
          }
          
          const secondAutoLink = this.querySelector('.upsell-add-to-cart-auto-2-link');
          if (secondAutoLink && secondProduct.variants && secondProduct.variants.length > 0) {
            secondAutoLink.setAttribute('data-product-id', secondProduct.variants[0].id);
            secondAutoLink.setAttribute('data-product-title', secondProduct.title);
          }
        }
      }
    } catch (error) {
      console.error("Erreur lors de la récupération des recommandations:", error);
    }
  }


}

// Enregistrer le custom element
if (!window.customElements.get("product-upsell")) {
  window.customElements.define("product-upsell", ProductUpsell);
}
